export const ipTransit = {
  title: 'IP Transit',
  subtitle: 'High-quality Internet connectivity with DDoS protection',
  features: {
    network: {
      title: 'Global Network',
      description: 'Direct connections with major carriers'
    },
    protection: {
      title: 'DDoS Protection',
      description: 'Optional protection up to 4 Tbps'
    },
    capacity: {
      title: 'High Capacity',
      description: 'Up to 10G bandwidth'
    }
  },
  specs: {
    title: 'Technical Specifications',
    items: [
      'Maximum capacity: 10G',
      'Contact us for custom quotes',
      'BGP Full Routes'
    ],
    benefitsList: [
      'Guaranteed minimum latency',
      '24/7 technical support',
      'Custom solutions for your needs'
    ]
  }
};